import { MenuEntry } from '@src/menu-entry';

export default [
    MenuEntry.create()
        .setRoute('short_url_list')
        .setAdditionalRoutes([
            'short_url_create',
            'short_url_edit',
        ]),
];
